const hiddenClass = 'selling_plan_theme_integration--hidden';

class SellingPlansWidget {
  constructor(sellingPlansWidgetContainer) {
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
    this.sellingPlanWrapper = document.querySelector('.selling_plan_wrapper');
    this.mainSubsWrapper = document.querySelector('.main-subs-wrapper')
    
    // Initialize but don't connect yet
    this.init();
    
    // Connect to the DOM
    this.connectedCallback();
  }
  
  init() {
    // Initial setup without DOM connections
    this.appendSellingPlanInputs();
    this.updateSellingPlanInputsValues();
  }
  
  connectedCallback() {
    this.listenToSellingPlanFormRadioButtonChange();
    // this.updatePrice();
    this.listenToSubscriptionChange();
    
    document.addEventListener('theme:variant:change', this.onVariantChanged.bind(this));
    
    this.addToCartForms.forEach(form => {
      form.addEventListener('submit', this.onFormSubmit.bind(this));
    });
    
    this.refresh();
  }
  
  disconnectedCallback() {
    document.removeEventListener('theme:variant:change', this.onVariantChanged.bind(this));
    
    this.addToCartForms.forEach(form => {
      form.removeEventListener('submit', this.onFormSubmit.bind(this));
    });
  }
  
  onVariantChanged(event) {
    if (event.detail && event.detail.variant) {
      this.refresh(event.detail.variant.id);
      if (event.detail.variant.available && event.detail.variant.selling_plan_allocations.length > 0) {
        this.mainSubsWrapper.classList.remove('hidden');
      } else {
        this.mainSubsWrapper.classList.add('hidden');

      }
    }
  }
  
  onFormSubmit(event) {
    this.updateSellingPlanInputsValues();
  }
  
  refresh(variantId) {
    if (variantId) {
      if (this.variantIdInput && this.variantIdInput.value !== variantId) {
        this.variantIdInput.value = variantId;
      }
    }
    
    this.handleSellingPlanFormVisibility();
    this.updateSellingPlanInputsValues();
    this.listenToSellingPlanFormRadioButtonChange();
    this.updatePrice();
  }

  get sectionId() {
    return this.sellingPlansWidgetContainer.getAttribute('data-section-id');
  }

  get shopifySection() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  /*
    We are careful to target the correct form, as there are instances when we encounter an installment form that we specifically aim to avoid interacting with.
  */
  get variantIdInput() {
    return (
      this.addToCartForms[1]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[1]?.querySelector(`select[name="id"]`) ||
      this.addToCartForms[0].querySelector(`input[name="id"]`) ||
      this.addToCartForms[0].querySelector(`select[name="id"]`)
    );
  }


  get comparedAtPrice() {
    return this.shopifySection.querySelector('.price__sale');
  }

  get visibleSellingPlanForm() {
    return this.shopifySection.querySelector(
      `section[data-variant-id^="${this.variantIdInput.value}"]`,
    );
  }

  get isVariantAvailable() {
    return this.selectedPurchaseOption.getAttributeNames().includes('disabled');
  }

  get sellingPlanInput() {
    return this.shopifySection.querySelector('.selected-selling-plan-id');
  }

  get addToCartForms() {
    return this.shopifySection.querySelectorAll('[action*="/cart/add"]');
  }


  /*
    To enable the addition of a selling plan to a cart, it's necessary to include an input with the name "selling_plan", which will carry the selling ID as its value. When a buyer clicks on 'add to cart', the appropriate selling plan ID is added to their cart.
  */
  appendSellingPlanInputs() {
    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.appendChild(this.sellingPlanInput.cloneNode());
    });
  }

  showSellingPlanForm(sellingPlanFormForSelectedVariant) {
    sellingPlanFormForSelectedVariant?.classList?.remove(hiddenClass);
  }

  hideSellingPlanForms(sellingPlanFormsForUnselectedVariants) {
    sellingPlanFormsForUnselectedVariants.forEach((element) => {
      element.classList.add(hiddenClass);
      //element.closest('.selling_plan_wrapper').classList.add('hidden');
    });
  }

  /*
    Each product variant comes with a selling plan selection box that the buyer can interact with.
    When a buyer chooses a different variant, we ensure that only the relevant selling plan selection box is displayed.
    This guarantees that only the selling plan associated with the selected variant is shown.
  */
  handleSellingPlanFormVisibility() {
    const sellingPlanFormForSelectedVariant = this.shopifySection.querySelector(
      `section[data-variant-id="${this.variantIdInput.value}"]`,
    );
    const sellingPlanFormsForUnselectedVariants =
      this.shopifySection.querySelectorAll(
        `.selling_plan_theme_integration:not([data-variant-id="${this.variantIdInput.value}"])`,
      );
    this.showSellingPlanForm(sellingPlanFormForSelectedVariant);
    this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants);
  }


  listenToSubscriptionChange() {
    this.activateSubscriptionInput.addEventListener('change', (evt) => {
        this.toggleSubscription(evt);
        this.listenToSellingPlanFormRadioButtonChange();
      });
  }


  get priceElement() {
    return document.querySelector('[data-product-price]');
  }

  // get salePriceElement() {
  //   return document.querySelector('.price__sale');
  // }

  // get salePriceValue() {
  //   return this.salePriceElement.querySelector('.price-item--sale');
  // }

  get compareAtPriceValue() {
    return document.querySelector('[data-compare-price]');
  }

  get activateSubscriptionInput() {
    return this.shopifySection.querySelector(`.activate-subscription`);
  }

  get sellingPlanRadioButton() {
    return this.shopifySection.querySelectorAll('.selling_plan--radio');
  }

  get savingAmountElement() {
    return this.visibleSellingPlanForm.querySelector('.saving-amount');
  }


  // get sellingPlanAllocationPrice() {
  //   return document.getElementById(
  //     `${this.selectedPurchaseOption.dataset.sellingPlanGroupId}_allocation_price`,
  //   );
  // }

  // get selectedPurchaseOptionPrice() {
  //   return this.selectedPurchaseOption?.dataset?.variantPrice;
  // }

  // get selectedPurchaseOptionComparedAtPrice() {
  //   return this.selectedPurchaseOption.dataset.variantCompareAtPrice;
  // }


  /*
    We aim to ascertain whether a compared price exists, which would indicate that the currently selected input has a discount applied to it.
    If a discount is detected, the discounted price is displayed; otherwise, the regular price is shown.
  */
  updatePrice() {
    const currentVisibleForm = this.shopifySection.querySelector(
      `section[data-variant-id^="${this.variantIdInput.value}"]`
    );
    
    const selectedRadio = currentVisibleForm?.querySelector('input[type="radio"]:checked');
    
    const currentPrice = selectedRadio?.dataset?.variantPrice;
    
    if (currentPrice) {
      document.querySelector('[data-add-to-cart]:not(disabled) .btn__text').innerHTML = "ADD TO BAG - " + currentPrice;
    }
    if(!!selectedRadio){
      if (this.savingAmountElement) {
        const savingAmount = parseFloat(selectedRadio?.dataset?.regularPrice) - parseFloat(selectedRadio?.dataset?.allocationRawPrice);
        this.savingAmountElement.innerHTML = 'Save £' + (savingAmount/ 100).toFixed(2);    
      }
      this.updatePDPPrice();
      this.updatePricePerMl();
    }
  }

  updatePDPPrice() {
    const selectedRadio = this.visibleSellingPlanForm?.querySelector('input[type="radio"]:checked');
    const currentPrice = selectedRadio?.dataset?.variantPrice;
    
    if (currentPrice) {
      this.priceElement.innerHTML = currentPrice.replace('.00', '');
    }
  }

  updatePricePerMl() {
    const pricePerMlHolder = document.querySelector('[data-price-per-ml]');
    if (!pricePerMlHolder) return; // Exit if the element is not found
  
    const sizeType = this.visibleSellingPlanForm?.dataset?.variantSizeType;
    const sizeValue = parseFloat(this.visibleSellingPlanForm?.dataset?.variantSizeValue || 0);

    const currentVisibleForm = this.shopifySection.querySelector(
      `section[data-variant-id^="${this.variantIdInput.value}"]`
    );

    const selectedRadio = currentVisibleForm?.querySelector('input[type="radio"]:checked');
    const currentPrice = selectedRadio?.dataset?.variantPriceRaw;
  
    // If sizeType or sizeValue are missing, clear out the content
    if (!sizeType || !sizeValue) {
      pricePerMlHolder.textContent = `(#${this.visibleSellingPlanForm?.dataset?.variantSkuItem})`;
      return;
    }
  
    // EXACT logic from the Liquid snippet:
    let comparisonAmount = 100;
    if(sizeType.charAt() == 'g') comparisonAmount = 10

    const amountInComparison = comparisonAmount / sizeValue;
    const pricePerComparison = currentPrice * amountInComparison;
  
    // Format the result using your theme's formatMoney helper
    const displayPrice = formatMoney(pricePerComparison, theme.moneyFormat);
  
    // Update the text content of the price-per-ml holder
    pricePerMlHolder.textContent = `${displayPrice.replace('.00', '')} Per ${comparisonAmount}${sizeType} (#${this.visibleSellingPlanForm?.dataset?.variantSkuItem})`;
  }


  toggleSubscription(evt) {
    if (evt.target.checked) {
      document.querySelectorAll('.selling_plan_wrapper').forEach((element) => {
        element.classList.remove('hidden');
         element.querySelector('.selling_plan--radio').checked = !element.querySelector('.selling_plan--radio').checked;
         this.handleRadioButtonChange(element.querySelector('.selling_plan--radio'));
      });
    } else {
      document.querySelectorAll('.selling_plan_wrapper').forEach((element) => {
        element.classList.add('hidden');
      });
    }
    // const firstRadio =  this.visibleSellingPlanForm.querySelector('.selling_plan--radio')
    // firstRadio.checked = !firstRadio.checked;
    if(this.visibleSellingPlanForm.querySelector('.selling_plan_wrapper').classList.contains('hidden')) {
      this.visibleSellingPlanForm.querySelectorAll('.selling_plan--radio').forEach((radio) => {
        radio.checked = false;
      })

      const oneTimeRadios = document.querySelectorAll('.selling_plan--one-time')
      oneTimeRadios.forEach((radio) => {
        radio.checked = true;
        this.handleRadioButtonChange(radio);
      })

    }
  }

  get sellingPlanInputs() {
    return this.shopifySection.querySelectorAll('.selected-selling-plan-id');
  }

  updateSellingPlanInputsValues() {
    this.sellingPlanInputs.forEach((sellingPlanInput) => {
      sellingPlanInput.value = this.sellingPlanInputValue;
    });
  }

  get sellingPlanInputValue() {
    return this.selectedPurchaseOption?.dataset.sellingPlanId ?? null;
  }

  get selectedPurchaseOption() {
    return this.visibleSellingPlanForm?.querySelector(
      'input[type="radio"]:checked',
    );
  }

  set selectedPurchaseOption(selectedPurchaseOption) {
    this._selectedPurchaseOption = selectedPurchaseOption;
  }

  handleRadioButtonChange(selectedPurchaseOption) {
    // this.selectedPurchaseOption = selectedPurchaseOption;
    this.updateSellingPlanInputsValues();
    this.updatePrice();
  }

  listenToSellingPlanFormRadioButtonChange() {
    this.visibleSellingPlanForm
      ?.querySelectorAll('input[type="radio"]')
      .forEach((radio) => {
        radio.addEventListener('change', (event) => {
          this.handleRadioButtonChange(event.target);
        });
      });
  }

}

document
  .querySelectorAll('.selling_plan_app_container')
  .forEach((sellingPlansWidgetContainer) => {
    new SellingPlansWidget(sellingPlansWidgetContainer);
  });